import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45257cd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "scrollable-content" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "company-info" }
const _hoisted_5 = { class: "company-logo" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "company-logo-placeholder"
}
const _hoisted_8 = { class: "company-details" }
const _hoisted_9 = { class: "company-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-subtitle" }, "Brand", -1))
const _hoisted_11 = { class: "social-info" }
const _hoisted_12 = { class: "social-logo" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "social-details" }
const _hoisted_15 = { class: "social-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "social-subtitle" }, "Social Account", -1))
const _hoisted_17 = {
  key: 0,
  class: "status-section"
}
const _hoisted_18 = { class: "status-content" }
const _hoisted_19 = { class: "status-title" }
const _hoisted_20 = { class: "status-subtitle" }
const _hoisted_21 = {
  key: 1,
  class: "instructions-section"
}
const _hoisted_22 = { class: "instructions-card" }
const _hoisted_23 = {
  key: 0,
  class: "content-title"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Content Title", -1))
const _hoisted_25 = {
  key: 1,
  class: "instructions-content"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "action-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "text-selectable modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.company.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.company.image,
                      alt: _ctx.company.title
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'building'] })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.company.title), 1),
                _hoisted_10
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: _ctx.social.image,
                  alt: _ctx.social.title
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.social.title), 1),
                _hoisted_16
              ])
            ])
          ]),
          (_ctx.actionInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(["status-card", 'status-card--' + _ctx.actionInfo.color])
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(_toDisplayString(_ctx.actionInfo.text) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.date), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.action), 1)
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.contentTitle || _ctx.instruction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.contentTitle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("p", null, _toDisplayString(_ctx.contentTitle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.instruction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.instructions")), 1),
                        _createElementVNode("div", {
                          class: "instructions-text",
                          innerHTML: _ctx.sanitizedInstruction
                        }, null, 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            class: "primary-action",
            onClick: _ctx.goToDeal
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'external-link'],
                class: "button-icon"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.go-to-deal")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}